import React from "react";
import { CtaButton } from "../CtaButton";
import { ContentIcon } from "../ContentIcon";
import { SectionHeading } from "../SectionHeading";
import { tools } from "../../data/content";
export function Tools() {
  return <section className="bg-navy px-4 py-16 sm:py-20" data-id="element-332" data-mp="2hiqb5db0i12n">
      <div className="mx-auto max-w-4xl" data-id="element-333" data-mp="2dig3zxbhh4m7">
        <SectionHeading tone="dark" eyebrow="Practical tools included inside the Blueprint™" title="Resources You Can Adapt to Your Professional Workflow." data-id="element-334" data-mp="2dho8snlst8wg" />
        <ul className="mt-10 space-y-3" data-id="element-335" data-mp="23ruyrr1b11ub">
          {tools.map(tool => <li key={tool.title} className="flex gap-4 rounded-2xl bg-white/[0.07] p-5 ring-1 ring-white/15" data-id="element-336" data-mp="1yt0f6mvij995">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-sun text-navy" data-id="element-337" data-mp="1tvi6mxleqw1o">
                <ContentIcon name={tool.icon} className="h-6 w-6" data-id="element-338" data-mp="1prk92rbqdtaq" />
              </span>
              <div data-id="element-339" data-mp="1kutts67r31qd">
                <h3 className="text-lg font-black leading-snug text-white" data-id="element-340" data-mp="1kuaktf02vnoh">{tool.title}</h3>
                <p className="mt-1 text-[15px] font-semibold leading-relaxed text-white/75" data-id="element-341" data-mp="157wp1u2wqofc">{tool.body}</p>
              </div>
            </li>)}
        </ul>
        <p className="mt-6 text-center text-sm font-semibold italic text-white/60" data-id="element-342" data-mp="w9b8g4gzxjh7">
          These tools are designed to support professional organization and educational planning—not replace
          individualized assessment or validated clinical instruments.
        </p>
        <div className="mt-10" data-id="element-343" data-mp="1sz22k2ldl4mh">
          <CtaButton tone="dark" label="Get my complete communication support toolkit" sub="Secure Checkout · One-Time Payment of $27" data-id="element-344" data-mp="1szaens9oc5wm" />
        </div>
      </div>
    </section>;
}